import type { NextRouter } from 'next/router';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

function normalizePath(asPathOrPathname: string): string {
  // remove query/hash
  let p = asPathOrPathname.split('#')[0].split('?')[0];

  // strip trailing slash except root
  if (p.length > 1 && p.endsWith('/')) p = p.slice(0, -1);

  // strip locale prefix like /en or /en-US
  p = p.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '');

  // ensure leading slash
  if (!p.startsWith('/')) p = `/${p}`;
  return p || '/';
}

function getLayoutPathnamesFromPath(p: string) {
  const pathname = normalizePath(p);
  const isMembersCheckout = pathname.startsWith('/members/checkout');

  return {
    isCheckout: pathname.startsWith('/checkout'),
    isMembers: pathname.startsWith('/members') || isMembersCheckout,
    isMembersCheckout,
    isMembersSubscriptionList: pathname.startsWith('/members/subscriptions')
  };
}

export function useLayoutPathname() {
  const router = useRouter();

  // SSR-safe: start with pathname (pattern) then swap to asPath on client
  const [path, setPath] = useState(router.asPath || router.pathname || '/');
  useEffect(() => {
    setPath(router.asPath || router.pathname || '/');
  }, [router.asPath, router.pathname]);

  return getLayoutPathnamesFromPath(path);
}

export function getLayoutPathnameFromRouter(router: NextRouter) {
  // If you only call this client-side, you can skip the fallback
  const path = router.asPath || router.pathname || '/';
  return getLayoutPathnamesFromPath(path);
}
